import { LegalSectionProps } from "./types";

/**
 * 法律文件的章節組件
 * 用於顯示法律文件中的章節，具有一致的樣式
 */
export function LegalSection({ title, children }: LegalSectionProps) {
  return (
    <div className="mb-8 last:mb-0">
      <h2 className="text-xl font-bold text-[#6B8E5A] mb-5 relative pb-3">
        {title}
        <span className="absolute bottom-0 left-0 w-16 h-1 bg-gradient-to-r from-[#6B8E5A] to-[#A0956B] rounded-full"></span>
      </h2>
      <div className="space-y-3 text-gray-700 text-opacity-90">{children}</div>
    </div>
  );
}
